import * as React from 'react';
import {ErrorInfo} from "react";

class ErrorBoundary extends React.Component<any, any> {
	constructor(props: any) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: Error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error };
	}

	componentDidCatch(error:Error, errorInfo: ErrorInfo) {
		// You can also log the error to an error reporting service
		console.log(error)
		// todo: implement error service
		// logErrorToMyService(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return <>
				<h1>Došlo je do greške!</h1>
				<p>{this.state.error.toString()}</p>
			</>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary
